import moment from 'moment-timezone';
var TIME_FORMAT = 'h:mm A';
var MONTH_ABBREV_FORMAT = 'MMM';
var ZERO_PAD_DAY_FORMAT = 'DD';
var DAY_AND_DATE_FORMAT = 'dddd, D MMM';
var SHORT_DAY_AND_DATE_FORMAT = 'ddd D MMM,';
var DAY_MONTH_YEAR_FORMAT = 'DD/MM/YYYY';
var DAY_MONTH_YEAR_WITH_SPACE = 'DD MMM YYYY';
var DAY_LONG_MONTH_YEAR_WITH_SPACE = 'DD MMMM YYYY';
var MONTH_DAY_YEAR_FORMAT = 'MMMM D, YYYY';
var formatOrNull = (date, formatString) => {
  if (!date) {
    return null;
  }
  var result = moment(date).format(formatString);
  if (result === 'Invalid date') {
    return null;
  }
  return result;
};
export var getTime = date => formatOrNull(date, TIME_FORMAT);
export var getShortMonth = date => formatOrNull(date, MONTH_ABBREV_FORMAT);
export var getDay = date => formatOrNull(date, ZERO_PAD_DAY_FORMAT);
export var getDayAndDate = date => formatOrNull(date, DAY_AND_DATE_FORMAT);
export var getShortDayAndDate = date => formatOrNull(date, SHORT_DAY_AND_DATE_FORMAT);
export var getDayMonthYear = date => formatOrNull(date, DAY_MONTH_YEAR_FORMAT);
export var getDayMonthYearWithSpace = date => formatOrNull(date, DAY_MONTH_YEAR_WITH_SPACE);
export var getDayLongMonthYearWithSpace = date => formatOrNull(date, DAY_LONG_MONTH_YEAR_WITH_SPACE);
export var getMonthDayYear = date => formatOrNull(date, MONTH_DAY_YEAR_FORMAT);